'use strict'

export class SubmitError extends Error {
  constructor(message = 'An error occurred while submitting a form') {
    super(message)
    this.name = 'SumbitError'
  }
}
